import axios from 'axios';
import { OrderSettlementType } from './Settlement.type';

export const getCustomerSettlementShow = (params: {
  date?: string;
  customerId?: number;
}) => axios.get<OrderSettlementType>('/order/settlement/customer', { params });

export const getSupplierSettlementShow = (params: {
  date?: string;
  supplierId?: number;
}) => axios.get<OrderSettlementType>('/order/settlement/supplier', { params });
